import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSearch, faHandshake, faKey, faChartLine, faFileContract } from '@fortawesome/free-solid-svg-icons';
import './Services.css';

function Services() {
  const services = [
    {
      icon: faSearch,
      title: "Căutare Proprietăți",
      description: "Găsim proprietatea perfectă care se potrivește nevoilor și bugetului dumneavoastră."
    },
    {
      icon: faFileContract,
      title: "Consultanță Imobiliară",
      description: "Oferim consultanță specializată pentru toate aspectele tranzacției imobiliare."
    },
    {
      icon: faChartLine,
      title: "Analiză de Piață",
      description: "Analize detaliate ale pieței pentru decizii informate și investiții sigure."
    },
    {
      icon: faHandshake,
      title: "Negociere",
      description: "Negociem în numele dumneavoastră pentru cele mai bune condiții și prețuri."
    },
    {
      icon: faFileContract,
      title: "Asistență Juridică",
      description: "Suport complet în procesul de documentare și aspecte juridice."
    },
    {
      icon: faKey,
      title: "Predare Cheie",
      description: "Gestionăm întregul proces până la momentul predării cheilor."
    }
  ];

  return (
    <section className="services-section">
      <Container>
        <div className="section-header">
          <h2>Serviciile Noastre</h2>
          <div className="underline"></div>
        </div>
        <Row>
          {services.map((service, index) => (
            <Col md={4} key={index}>
              <div className="service-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="icon-wrapper">
                  <FontAwesomeIcon icon={service.icon} className="service-icon" />
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <div className="hover-effect"></div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Services;